(function () {
  'use strict';

  if (window.__filterSecondaryMenuBound) return;
  window.__filterSecondaryMenuBound = true;

  function selectedOption(view) {
    if (!view) return null;
    return view.querySelector('[data-filter-option]:checked');
  }

  function setFooter(root, view) {
    var apply = root.querySelector('[data-filter-apply]');
    var clear = root.querySelector('[data-filter-clear]');
    var selected = selectedOption(view);
    if (apply) apply.disabled = !selected;
    if (clear) clear.hidden = !selected;
  }

  function hideViews(root) {
    root.querySelectorAll('[data-filter-view]').forEach(function (view) {
      view.hidden = true;
    });
  }

  function showView(root, name, title) {
    hideViews(root);
    var view = root.querySelector('[data-filter-view="' + name + '"]');
    if (!view) return null;
    view.hidden = false;
    var titleNode = root.querySelector('[data-filter-panel-title]');
    if (titleNode) {
      titleNode.textContent = title || view.getAttribute('data-filter-view-title') || '';
    }
    root.setAttribute('data-active-view', name);
    setFooter(root, view);
    return view;
  }

  function firstGroupView(root) {
    var views = root.querySelectorAll('[data-filter-view^="group-"]');
    return views.length ? views[0] : null;
  }

  function openFilterView(root) {
    var index = root.querySelector('[data-filter-view="index"]');
    if (index) {
      return showView(root, 'index', index.getAttribute('data-filter-view-title'));
    }
    var group = firstGroupView(root);
    if (!group) return null;
    return showView(root, group.getAttribute('data-filter-view'), group.getAttribute('data-filter-view-title'));
  }

  function setTriggers(root, openKind) {
    root.querySelectorAll('[data-filter-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', btn.getAttribute('data-filter-open') === openKind ? 'true' : 'false');
    });
  }

  function closeMenu(root) {
    var dialog = root.querySelector('[data-filter-dialog]');
    if (dialog && dialog.open) dialog.close();
    setTriggers(root, '');
    root.removeAttribute('data-active-view');
  }

  function openMenu(root, kind) {
    var dialog = root.querySelector('[data-filter-dialog]');
    if (!dialog) return;
    if (kind === 'sort') {
      showView(root, 'sort');
    } else {
      openFilterView(root);
    }
    if (!dialog.open) dialog.showModal();
    setTriggers(root, kind);
    var closeBtn = root.querySelector('[data-filter-back]');
    if (closeBtn) closeBtn.focus();
  }

  function navigate(url) {
    if (!url) return;
    window.location.href = url;
  }

  function currentSortUrl(value) {
    var url = new URL(window.location.href);
    if (value) {
      url.searchParams.set('sort_by', value);
    } else {
      url.searchParams.delete('sort_by');
    }
    return url.toString();
  }

  function clearAllUrl(root) {
    var base = root.getAttribute('data-clear-url') || window.location.pathname;
    var url = new URL(base, window.location.origin);
    var sort = new URL(window.location.href).searchParams.get('sort_by');
    if (sort) url.searchParams.set('sort_by', sort);
    var q = new URL(window.location.href).searchParams.get('q');
    if (q) url.searchParams.set('q', q);
    return url.toString();
  }

  function chipLabel(title, template) {
    var safe = String(title || '').slice(0, 20);
    return (template || 'Quitar __L__').replace('__L__', safe);
  }

  function syncApplied(root) {
    var chips = root.querySelector('[data-filter-chips]');
    var list = root.querySelector('.filter-menu__chip-list');
    if (!chips || !list) return;
    var hasChips = list.children.length > 0;
    chips.hidden = !hasChips;
    root.classList.toggle('is-applied', hasChips);
  }

  function addStaticChip(root, option) {
    var list = root.querySelector('.filter-menu__chip-list');
    if (!list || !option) return;
    var id = option.getAttribute('data-option-id') || option.value;
    if (list.querySelector('[data-option-id="' + id + '"]')) return;
    var labelNode = option.closest('label');
    var title = labelNode ? (labelNode.querySelector('.filter-menu__option-label') || {}).textContent || '' : '';
    title = title.trim().slice(0, 20);
    if (!title) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'filter-menu__chip label-1';
    btn.setAttribute('data-filter-chip', '');
    btn.setAttribute('data-option-id', id);
    btn.setAttribute('aria-label', chipLabel(title, root.getAttribute('data-remove-template')));
    btn.innerHTML = '<span></span>';
    btn.querySelector('span').textContent = title;
    var iconSource = root.querySelector('[data-filter-chip-icon] .filter-menu__chip-x');
    if (iconSource) {
      btn.appendChild(iconSource.cloneNode(true));
    }
    list.appendChild(btn);
    syncApplied(root);
  }

  function removeStaticChip(root, optionId) {
    var list = root.querySelector('.filter-menu__chip-list');
    if (!list || !optionId) return;
    var chip = list.querySelector('[data-option-id="' + optionId + '"]');
    if (chip) chip.remove();
    var radio = root.querySelector('[data-filter-option][data-option-id="' + optionId + '"]');
    if (radio) radio.checked = false;
    syncApplied(root);
  }

  function applyStorefront(root, view) {
    var kind = root.getAttribute('data-active-view');
    var selected = selectedOption(view);
    if (!selected) return;
    if (kind === 'sort') {
      navigate(currentSortUrl(selected.value));
      return;
    }
    navigate(selected.getAttribute('data-url-add'));
  }

  function applyStatic(root, view) {
    var kind = root.getAttribute('data-active-view');
    var selected = selectedOption(view);
    if (!selected) return;
    if (kind !== 'sort') {
      addStaticChip(root, selected);
    }
    closeMenu(root);
  }

  function bindRoot(root) {
    if (root.getAttribute('data-filter-bound') === 'true') return;
    root.setAttribute('data-filter-bound', 'true');

    var dialog = root.querySelector('[data-filter-dialog]');

    root.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-filter-open]');
      if (openBtn && root.contains(openBtn)) {
        openMenu(root, openBtn.getAttribute('data-filter-open'));
        return;
      }

      var indexBtn = event.target.closest('[data-filter-open-view]');
      if (indexBtn && root.contains(indexBtn)) {
        showView(root, indexBtn.getAttribute('data-filter-open-view'), indexBtn.getAttribute('data-filter-view-title'));
        return;
      }

      var backBtn = event.target.closest('[data-filter-back]');
      if (backBtn && root.contains(backBtn)) {
        var active = root.getAttribute('data-active-view') || '';
        var index = root.querySelector('[data-filter-view="index"]');
        if (index && active.indexOf('group-') === 0) {
          showView(root, 'index', index.getAttribute('data-filter-view-title'));
        } else {
          closeMenu(root);
        }
        return;
      }

      var applyBtn = event.target.closest('[data-filter-apply]');
      if (applyBtn && root.contains(applyBtn)) {
        var view = root.querySelector('[data-filter-view]:not([hidden])');
        if (root.getAttribute('data-mode') === 'storefront') {
          applyStorefront(root, view);
        } else {
          applyStatic(root, view);
        }
        return;
      }

      var clearBtn = event.target.closest('[data-filter-clear]');
      if (clearBtn && root.contains(clearBtn)) {
        var current = root.querySelector('[data-filter-view]:not([hidden])');
        if (current) {
          current.querySelectorAll('[data-filter-option]').forEach(function (input) {
            input.checked = false;
          });
          setFooter(root, current);
        }
        return;
      }

      var clearAll = event.target.closest('[data-filter-clear-all]');
      if (clearAll && root.contains(clearAll)) {
        if (root.getAttribute('data-mode') === 'storefront') {
          navigate(clearAllUrl(root));
        } else {
          root.querySelectorAll('[data-filter-chip]').forEach(function (chip) {
            chip.remove();
          });
          root.querySelectorAll('[data-filter-option]').forEach(function (input) {
            if (input.name && input.name.indexOf('-sort') === -1) input.checked = false;
          });
          syncApplied(root);
        }
        return;
      }

      var chip = event.target.closest('[data-filter-chip]');
      if (chip && root.contains(chip)) {
        if (root.getAttribute('data-mode') === 'storefront') {
          navigate(chip.getAttribute('data-url-remove'));
        } else {
          removeStaticChip(root, chip.getAttribute('data-option-id'));
        }
      }
    });

    root.addEventListener('change', function (event) {
      if (!event.target.closest('[data-filter-option]')) return;
      setFooter(root, root.querySelector('[data-filter-view]:not([hidden])'));
    });

    if (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeMenu(root);
      });
      dialog.addEventListener('cancel', function () {
        setTriggers(root, '');
        root.removeAttribute('data-active-view');
      });
    }

    if (root.getAttribute('data-open-panel') === 'filter') {
      openMenu(root, 'filter');
    }
  }

  function init() {
    document.querySelectorAll('[data-filter-menu]').forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-filter-menu]').forEach(bindRoot);
    if (event.target.matches && event.target.matches('[data-filter-menu]')) {
      bindRoot(event.target);
    }
  });
})();
